import { cn } from 'src/frames/utils/cn';

import './EmergencyIcon.scss';

type PropsT = {
  className?: any;
};

export const EmergencyIcon = (props: PropsT) => {
  return (
    <svg
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          className={cn('EmergencyIcon')}
          d="M1 21 12 2l11 19H1zm10-6h2v-5h-2v5zm1 3a.968.968 0 0 0 .713-.288A.967.967 0 0 0 13 17a.967.967 0 0 0-.287-.712A.968.968 0 0 0 12 16a.965.965 0 0 0-.712.288A.965.965 0 0 0 11 17c0 .283.096.52.288.712A.965.965 0 0 0 12 18zm-7.55 1h15.1L12 6 4.45 19z"
          fill="#BE0032"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};
